import * as yup from "yup";
import { POST_CODE_VALIDATION_REGEX, NAME_CYR_OR_LAT_VALIDATION_REGEX } from "../../utils/regexExpressions";
import { initializeYup } from "../../utils/yupUtils";
import i18n from "i18next";

export const createContactAddressValidationSchema = () => {
  initializeYup(yup);
  const contactAddressValidationSchema = yup
    .object({
      fax: yup.string().optional().max(70, i18n.t("validation.charCount.invalid.70")),
      email: yup.string().required().email().max(100, i18n.t("validation.charCount.invalid.100")),
      postBox: yup.string().optional().max(100, i18n.t("validation.charCount.invalid.100")),
    })
    .concat(createBaseAddressFullValidationSchema());

  return contactAddressValidationSchema;
};

export const createReceiverAddressValidationSchema = () => {
  initializeYup(yup);

  const receiverAddressValidationSchema = yup
    .object({
      name: yup.string().required().matches(NAME_CYR_OR_LAT_VALIDATION_REGEX),
    })
    .concat(createBaseAddressFullValidationSchema());

  return receiverAddressValidationSchema;
};

const createBaseAddressFullValidationSchema = () => {
  initializeYup(yup);

  const baseAddressValidationSchema = yup.object({
    city: yup.mixed().when("country.id", {
      is: (id) => id !== "BG",
      then: yup.string().required().max(50, i18n.t("validation.charCount.invalid.50")),
    }),
    postCode: yup
      .string()
      .required()
      .matches(POST_CODE_VALIDATION_REGEX)
      .max(12, i18n.t("validation.charCount.invalid.12")),
    address: yup.string().required().max(2000, i18n.t("validation.charCount.invalid.2000")),
    phone: yup.string().required().max(120, i18n.t("validation.charCount.invalid.120")),
    country: yup.object({
      id: yup.string().required(),
    }),
    settlement: yup.mixed().when("country.id", {
      is: (id) => id === "BG",
      then: yup.object().shape({
        id: yup.string().required().max(50, i18n.t("validation.charCount.invalid.50")),
      }),
    }),
    postBox: yup.string().optional().max(100, i18n.t("validation.charCount.invalid.100")),
    email: yup.string().optional().email().max(100, i18n.t("validation.charCount.invalid.100")),
    fax: yup.string().optional().max(70, i18n.t("validation.charCount.invalid.70")),
  });

  return baseAddressValidationSchema;
};
